const ROOT_PARENT_SECTION_ID = '-';
function convertSectionsToTree(sections) {
    // Create a map of sectionId to TreeNode
    const sectionMap = sections.reduce((acc, current) => {
        acc[current.sectionId] = {
            ...current,
            children: [],
        };
        return acc;
    }, {});
    const roots = [];
    // Build the tree structure
    sections.forEach(section => {
        if (section.parentSectionId.startsWith(ROOT_PARENT_SECTION_ID)) {
            roots.push(sectionMap[section.sectionId]);
        }
        else {
            const parent = sectionMap[section.parentSectionId];
            if (parent) {
                parent.children.push(sectionMap[section.sectionId]);
            }
        }
    });
    return roots;
}
export default convertSectionsToTree;
